module.exports = __webpack_public_path__ + "img/programme8.d187079c.png";